import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import { types } from "./actionTypes";
import { AxiosResponse } from "axios";
//medthods
import {
  postApi,
  getApi,
  deleteApi,
  putApi,
  getApiForPhoneOtp,
  postApiforOtp,
  getApiForProductCertification,
} from "../../helpers/auth_helpers";

// workers
function* workerGetProducts({ filters, callback }: any) {
  let offset = filters?.offset ? filters?.offset : 0;
  let limit = filters?.limit ? filters?.limit : 10;
  let ProductId = filters?.ProductId ? filters?.ProductId : "";
  let ProductsName = filters?.ProductsName ? filters?.ProductsName : "";
  let categoryId = filters?.categoryId ? filters?.categoryId : "";
  let categoryName = filters?.categoryName ? filters.categoryName : "";
  // Selling price range from the price filter (same params as the catalogue picker); empty values are left out.
  const price = filters?.price || {};
  const priceQuery = [
    "minSellPrice", "maxSellPrice", "minSellPriceInclusive", "maxSellPriceInclusive", "priceStatus", "includeUnpriced",
  ]
    .filter((key) => price[key] !== undefined && price[key] !== null && price[key] !== "")
    .map((key) => "&" + key + "=" + encodeURIComponent(String(price[key])))
    .join("");
  let subCategoryId = filters?.subCategoryId ? filters?.subCategoryId : "";
  let weaveTypeId = filters?.weaveTypeId ? filters?.weaveTypeId : "";
  let artformId = filters?.artformId ? filters?.artformId : "";
  let typeId = filters?.typeId ? filters?.typeId : "";
  let sortBy = filters?.sortBy ? filters?.sortBy : "createdAt";
  let orderBy = filters?.orderBy ? filters?.orderBy : "-1";
  let tags = filters?.tags ? filters?.tags : "";
  let xuid = filters?.xuid ? filters?.xuid : '';
  let color = filters?.color ? filters.color : "";
  let createdAfter = filters?.createdAfter ? filters.createdAfter : "";
  let createdBefore = filters?.createdBefore ? filters.createdBefore : "";
  let q = filters?.q ? filters.q : "";
  let includeAiQuery =
    filters?.includeAiSuggestions === false
      ? "&includeAiSuggestions=false"
      : "&includeAiSuggestions=true";
  let inStockQuery =
    filters?.inStock === true || filters?.inStock === false
      ? "&inStock=" + filters.inStock
      : filters?.inStock?.value === "true" || filters?.inStock?.value === "false"
      ? "&inStock=" + filters.inStock.value
      : "";
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL +
      "/product/products?offset=" +
      offset +
      "&limit=" +
      limit +
      "&name=" +
      ProductsName +
      "&productId=" +
      ProductId +
      "&artFormId=" +
      artformId +
      "&typeId=" +
      typeId +
      "&categoryId=" +
      categoryId +
      "&subcategoryId=" +
      subCategoryId +
      "&weavetypeId=" +
      weaveTypeId +
      "&sortBy=" +
      sortBy +
      "&tags=" +
      tags +
      "&orderBy=" +
      orderBy + "&xuid=" + xuid + inStockQuery +
      (color ? "&color=" + encodeURIComponent(color) : "") +
      (createdAfter ? "&createdAfter=" + encodeURIComponent(createdAfter) : "") +
      (createdBefore ? "&createdBefore=" + encodeURIComponent(createdBefore) : "") +
      (q ? "&q=" + encodeURIComponent(q) : "") +
      (filters?.view ? "&view=" + encodeURIComponent(filters.view) : "") +
      (categoryName ? "&categoryName=" + encodeURIComponent(categoryName) : "") +
      // Live pieces with saved-but-unpublished edits (draft revisions); sent only when asked for.
      (filters?.hasDraftChanges === true ? "&hasDraftChanges=true" : "") +
      (Array.isArray(filters?.typeTagIds) && filters.typeTagIds.length
        ? "&typeTagIds=" + encodeURIComponent(filters.typeTagIds.join(","))
        : "") +
      (filters?.typeTagReview === "PENDING" ? "&typeTagReview=PENDING" : "") +
      // Needs photo tab (photo updates on); the backend ignores it when the feature is off.
      (filters?.needsPhotoUpdate === true ? "&needsPhotoUpdate=true" : "") +
      (filters?.needsPhotoUpdate === true && filters?.photoUpdateReason
        ? "&photoUpdateReason=" + encodeURIComponent(filters.photoUpdateReason)
        : "") +
      priceQuery +
      includeAiQuery;
    const response: AxiosResponse = yield call(getApi, url);
    callback(response);
    yield put({
      type: types.GET_PRODUCTS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    if (typeof callback === "function") callback({ success: false, code: "NETWORK_UNAVAILABLE" });
  }
}
function* workerGetProductById({ filters, callback }: any) {
  let offset = filters?.offset ? filters?.offset : 0;
  let limit = filters?.limit ? filters?.limit : 10;
  let ProductId = filters?.ProductId ? filters?.ProductId : "";
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL +
      "/product/productById?offset=" +
      offset +
      "&limit=" +
      limit +
      "&productId=" +
      ProductId;
    const response: AxiosResponse = yield call(getApi, url);
    callback(response);
    yield put({
      type: types.GET_PRODUCTS_BY_ID_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerGetProductByIdAfterLycToken({ filters, callback }: any) {
  let offset = filters?.offset ? filters?.offset : 0;
  let limit = filters?.limit ? filters?.limit : 10;
  let ProductId = filters?.ProductId ? filters?.ProductId : "";
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL +
      "/product/singleProductById?offset=" +
      offset +
      "&limit=" +
      limit +
      "&productId=" +
      ProductId;
    const response: AxiosResponse = yield call(
      getApiForProductCertification,
      url
    );
    callback(response);
    yield put({
      type: types.GET_PRODUCT_BY_ID_AFTER_KYC_TOKEN_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerGetProductByIdForProductCertification({
  filters,
  callback,
}: any) {
  let offset = filters?.offset ? filters?.offset : 0;
  let limit = filters?.limit ? filters?.limit : 10;
  let ProductId = filters?.ProductId ? filters?.ProductId : "";
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL +
      "/product/productById?offset=" +
      offset +
      "&limit=" +
      limit +
      "&productId=" +
      ProductId;
    const response: AxiosResponse = yield call(
      getApiForProductCertification,
      url
    );
    callback(response);
    yield put({
      type: types.GET_PRODUCTS_BY_ID_SUCCESS_PRODUCT_CERTIFICATION,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerCreateProducts({ payload, callback }: any) {
  try {
    const url: string = process.env.REACT_APP_SERVERURL + "/product/create";
    const response: AxiosResponse = yield call(postApi, url, payload);
    callback(response);
    yield put({
      type: types.CREATE_PRODUCTS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    if (typeof callback === "function") {
      callback({
        success: false,
        code: "NETWORK_UNAVAILABLE",
        message: "Could not reach the server. Check your connection and try again.",
      });
    }
  }
}
function* workerUpdateProducts({ payload, callback }: any) {
  try {
    const url: string = process.env.REACT_APP_SERVERURL + "/product/update";
    const response: AxiosResponse = yield call(putApi, url, payload);
    callback(response);
    yield put({
      type: types.UPDATE_PRODUCTS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    if (typeof callback === "function") callback({ success: false, code: "NETWORK_UNAVAILABLE" });
  }
}
function* workerDeleteProducts({ payload, callback }: any) {
  try {
    const url: string = process.env.REACT_APP_SERVERURL + "/product/delete";
    const response: AxiosResponse = yield call(deleteApi, url, payload);
    callback(response);
    yield put({
      type: types.DELETE_PRODUCTS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerProductVerifyOtp({ payload, callback }: any) {
  let mobile: any = payload?.mobile;
  let otp: any = payload?.otp;
  try {
    const url: string = process.env.REACT_APP_SERVERURL + "/otp/generate";

    const response: AxiosResponse = yield call(postApi, url);
    callback(response);
    yield put({
      type: types.SEND_OTP_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerSendOtp({ payload, callback }: any) {
  let mobile: any = payload?.mobile;
  let otp: any = payload?.otp;
  try {
    const url: string = process.env.REACT_APP_SERVERURL + "/otp/generate";
    const response: AxiosResponse = yield call(postApi, url, payload);
    callback(response);

    yield put({
      type: types.PRODUCT_VERIFY_OTP_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerReSendOtp({ payload, callback }: any) {
  let mobile: any = payload?.mobile;
  let otp: any = payload?.otp;
  try {
    const url: string =
      process.env.REACT_APP_OTP_URL +
      "/otp/verify?authkey=370481Aq8yhs5eJ7461b06d95P1&mobile=91" +
      mobile +
      "&otp=" +
      otp;
    const response: AxiosResponse = yield call(postApiforOtp, url);
    callback(response);

    yield put({
      type: types.PRODUCT_VERIFY_OTP_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workeRProductKYC({ payload, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL + "/productkyc/kycToken";
    const response: AxiosResponse = yield call(postApi, url, payload);
    callback(response);
    yield put({
      type: types.PRODUCT_KYC_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerCreateProductVariant({ payload, callback }: any) {
  try {
    const url: string = process.env.REACT_APP_SERVERURL + "/varient/create";
    const response: AxiosResponse = yield call(postApi, url, payload);
    callback(response);
    yield put({
      type: types.CREATE_PRODUCT_VARIANT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
// function* workerSendOtp({ payload, callback }: any) {
//   try {
//     const url: string = process.env.REACT_APP_OTP_URL + "/product/sendOTP";
//     const response: AxiosResponse = yield call(getApiForPhoneOtp, url);
//     callback(response);
//     yield put({
//       type: types.SEND_OTP_SUCCESS,
//       payload: response,
//     });
//   } catch (e) {
//     console.log(e);
//   }
// }

function* workerChangeProductStatus({ payload, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL + "/product/togglearchive";
    const response: AxiosResponse = yield call(postApi, url, payload);
    callback(response);
    yield put({
      type: types.CHANGE_PRODUCT_STATUS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerCollectFakeAlertDetails({ payload, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL + "/Certificate/save-report-data";
    const response: AxiosResponse = yield call(postApi, url, payload);
    callback(response);
    yield put({
      type: types.COLLECT_FAKE_ALERT_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerTransferProduct({ payload, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL + "/product/transferProductOwnership";
    const response: AxiosResponse = yield call(putApi, url, payload);
    callback(response);
    yield put({
      type: types.TRANSFERR_PRODUCT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerUndoTransferProduct({ payload, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL + "/product/undotransferProductOwnership";
    const response: AxiosResponse = yield call(putApi, url, payload);
    callback(response);
    yield put({
      type: types.UNDO_TRANSFERED_PRODUCT_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerUpdateProductInStock({ payload, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL + "/product/in-stock";
    const response: AxiosResponse = yield call(putApi, url, payload);
    callback(response);
    yield put({
      type: types.UPDATE_PRODUCT_IN_STOCK_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    if (typeof callback === "function") {
      callback({ success: false, message: "Failed to update stock" });
    }
  }
}
function* workerUpdateProductPrices({ payload, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL + "/product/prices";
    const response: AxiosResponse = yield call(putApi, url, payload);
    callback(response);
    yield put({
      type: types.UPDATE_PRODUCT_PRICES_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    if (typeof callback === "function") {
      callback({ success: false, message: "Failed to update prices" });
    }
  }
}
function* workerAddNfcTagId({ payload, callback }: any) {
  try {
    const url: string = process.env.REACT_APP_SERVERURL + "/product/addnfcTags";
    const response: AxiosResponse = yield call(putApi, url, payload);
    callback(response);
    yield put({
      type: types.ADD_NFC_TAG_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
  }
}
function* workerEnrichProductAi({ productId, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL +
      "/product/" +
      encodeURIComponent(productId) +
      "/ai-enrichment";
    const response: AxiosResponse = yield call(postApi, url, {});
    callback(response);
    yield put({ type: types.ENRICH_PRODUCT_AI_SUCCESS, payload: response });
  } catch (e) {
    console.log(e);
    callback({ success: false, message: "Unable to analyse product photo" });
  }
}
function* workerAcceptProductAi({ productId, payload, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL +
      "/product/" +
      encodeURIComponent(productId) +
      "/ai-enrichment/accept";
    const response: AxiosResponse = yield call(postApi, url, payload);
    callback(response);
    yield put({ type: types.ACCEPT_PRODUCT_AI_SUCCESS, payload: response });
  } catch (e) {
    console.log(e);
    callback({ success: false, message: "Unable to apply suggestions" });
  }
}
function* workerRejectProductAi({ productId, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL +
      "/product/" +
      encodeURIComponent(productId) +
      "/ai-enrichment/reject";
    const response: AxiosResponse = yield call(postApi, url, {});
    callback(response);
    yield put({ type: types.REJECT_PRODUCT_AI_SUCCESS, payload: response });
  } catch (e) {
    console.log(e);
    callback({ success: false, message: "Unable to dismiss suggestions" });
  }
}
function* workerGetSimilarProducts({ productId, callback }: any) {
  try {
    const url: string =
      process.env.REACT_APP_SERVERURL +
      "/product/" +
      encodeURIComponent(productId) +
      "/similar?limit=8";
    const response: AxiosResponse = yield call(getApi, url);
    callback(response);
    yield put({ type: types.GET_SIMILAR_PRODUCTS_SUCCESS, payload: response });
  } catch (e) {
    console.log(e);
    callback({ success: false, message: "Unable to find similar products" });
  }
}
// watchers
export function* watchTransferProduct() {
  yield takeEvery(types.TRANSFERR_PRODUCT, workerTransferProduct);
}
export function* watchUndoTransferProduct() {
  yield takeEvery(types.UNDO_TRANSFERED_PRODUCT, workerUndoTransferProduct);
}
export function* watchUpdateProductInStock() {
  yield takeEvery(types.UPDATE_PRODUCT_IN_STOCK, workerUpdateProductInStock);
}
export function* watchUpdateProductPrices() {
  yield takeEvery(types.UPDATE_PRODUCT_PRICES, workerUpdateProductPrices);
}
export function* watchAddNfcTagId() {
  yield takeEvery(types.ADD_NFC_TAG, workerAddNfcTagId);
}
export function* watchEnrichProductAi() {
  yield takeEvery(types.ENRICH_PRODUCT_AI, workerEnrichProductAi);
}
export function* watchAcceptProductAi() {
  yield takeEvery(types.ACCEPT_PRODUCT_AI, workerAcceptProductAi);
}
export function* watchRejectProductAi() {
  yield takeEvery(types.REJECT_PRODUCT_AI, workerRejectProductAi);
}
export function* watchGetSimilarProducts() {
  yield takeEvery(types.GET_SIMILAR_PRODUCTS, workerGetSimilarProducts);
}
export function* watchCollectFakeAlertDetails() {
  yield takeEvery(
    types.COLLECT_FAKE_ALERT_DETAILS,
    workerCollectFakeAlertDetails
  );
}
export function* watchGetProducts() {
  yield takeEvery(types.GET_PRODUCTS, workerGetProducts);
}
export function* watchGetProductsById() {
  yield takeEvery(types.GET_PRODUCTS_BY_ID, workerGetProductById);
}
export function* watchGetProductsByIdProductCer() {
  yield takeEvery(
    types.GET_PRODUCTS_BY_ID_PRODUCT_CERTIFICATION,
    workerGetProductByIdForProductCertification
  );
}
export function* watchGetProductByIdAfterLycToken() {
  yield takeEvery(
    types.GET_PRODUCT_BY_ID_AFTER_KYC_TOKEN,
    workerGetProductByIdAfterLycToken
  );
}
export function* watchCreateProducts() {
  yield takeEvery(types.CREATE_PRODUCTS, workerCreateProducts);
}
export function* watchUpdateProducts() {
  yield takeEvery(types.UPDATE_PRODUCTS, workerUpdateProducts);
}
export function* watchDeleteProducts() {
  yield takeEvery(types.DELETE_PRODUCTS, workerDeleteProducts);
}
export function* watchProductVerifyOtp() {
  yield takeEvery(types.PRODUCT_VERIFY_OTP, workerProductVerifyOtp);
}
export function* watchProductSendOtp() {
  yield takeEvery(types.SEND_OTP, workerSendOtp);
}
export function* watchProductReSendOtp() {
  yield takeEvery(types.PRODUCT_RESEND_OTP, workerReSendOtp);
}
export function* watchProductKYC() {
  yield takeEvery(types.PRODUCT_KYC, workeRProductKYC);
}
export function* watchCreateVariantProduct() {
  yield takeEvery(types.CREATE_PRODUCT_VARIANT, workerCreateProductVariant);
}
export function* watchChangeProductStatus() {
  yield takeEvery(types.CHANGE_PRODUCT_STATUS, workerChangeProductStatus);
}
function* productSaga() {
  yield all([fork(watchAddNfcTagId)]);
  yield all([fork(watchUndoTransferProduct)]);
  yield all([fork(watchUpdateProductInStock)]);
  yield all([fork(watchUpdateProductPrices)]);
  yield all([fork(watchTransferProduct)]);
  yield all([fork(watchGetProducts)]);
  yield all([fork(watchCreateProducts)]);
  yield all([fork(watchUpdateProducts)]);
  yield all([fork(watchDeleteProducts)]);
  yield all([fork(watchGetProductsById)]);
  yield all([fork(watchProductVerifyOtp)]);
  yield all([fork(watchProductSendOtp)]);
  yield all([fork(watchProductReSendOtp)]);
  yield all([fork(watchProductKYC)]);
  yield all([fork(watchCreateVariantProduct)]);
  yield all([fork(watchChangeProductStatus)]);
  yield all([fork(watchGetProductsByIdProductCer)]);
  yield all([fork(watchGetProductByIdAfterLycToken)]);
  yield all([fork(watchCollectFakeAlertDetails)]);
  yield all([fork(watchEnrichProductAi)]);
  yield all([fork(watchAcceptProductAi)]);
  yield all([fork(watchRejectProductAi)]);
  yield all([fork(watchGetSimilarProducts)]);
}
export default productSaga;
